import { render, staticRenderFns } from "./common.vue?vue&type=template&id=dd179814&scoped=true"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"
import style0 from "./common.vue?vue&type=style&index=0&id=dd179814&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd179814",
  null
  
)

export default component.exports